import React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/components/ui'

export default function ControlTooltip({
  children,
  text,
  side = 'left',
}: {
  children: React.ReactNode
  text: string
  side?: 'left' | 'top' | 'right' | 'bottom'
}) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>
          <span>{text}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
